<template>
  <section class="wrapper">
    <van-form @submit="save">
      <van-field
        is-link
        input-align="right"
        v-model="applyInfo.Post.text"
        label="发起岗位"
        placeholder="请选择"
        readonly
        :rules="[{ required: true, message: '请先设置用户岗位' }]"
        @click="showPostPicker=true"
      />
      <van-field
        input-align="right"
        v-model="applyInfo.summary"
        rows="1"
        autosize
        label="审批事由"
        type="textarea"
      />
      <van-collapse v-model="activeNames">
        <div class="van-remove-detail-items" v-for="(detail,index) in applyInfo.details" :key="index">
          <label class="van-remove-detail" v-if="index>0"><i class="iconfont iconfont-guanbi iconfont-style" @click="removeDetails(index)"></i></label>
          <van-collapse-item :title="`请假明细${index+1}`" :name="index">
            <van-field
              is-link
              input-align="right"
              v-model="detail.DtsInvType"
              label="请假类型"
              placeholder="请选择"
              readonly
              @click="detail.showWindows.showTakeOffType=true"
              :rules="[{ required: true, message: '请选择请假类型' }]"
            />
            <van-field
              is-link
              class="mt10"
              input-align="right"
              v-model="detail.BeginDate"
              label="开始时间"
              readonly
              placeholder="请选择"
              @click="detail.showWindows.showStartDate=true"
              :rules="[{ required: true, message: '请选择开始时间' }]"
            />
            <van-field
              is-link
              input-align="right"
              v-model="detail.EndDate"
              label="结束时间"
              readonly
              placeholder="请选择"
              @click="detail.showWindows.showEndDate=true"
              :rules="[{ required: true, message: '请选择结束时间' }]"
            />
            <van-field
              input-align="right"
              v-model="detail.subsidyAmt"
              label="请假时长"
              readonly
              placeholder="请输入"
              :rules="[{ required: true, message: '请输入请假时长' }]"
            />
            <van-field
              is-link
              input-align="right"
              v-model="detail.DtsInvTypeUnit"
              label="单位"
              readonly
              placeholder="请选择"
              :rules="[{ required: true, message: '请选择单位' }]"
            />
            <van-field
              class="mt10"
              input-align="right"
              v-model="detail.Remark"
              rows="4"
              autosize
              label="请假事由"
              type="textarea"
              placeholder="请输入请假事由"
            />
            <van-field class="mt10" input-align="right" label="说明附件">
              <template #input>
                <van-uploader v-model="detail.uploader" :after-read="(file)=>{
                    //自行上传文件
                    detail.uploader.forEach((item, index) => {
                      fileUpload(item.file,detail).then(response=>{
                         if (response.success) {
                            detail.fileList.push({
                              frGuid: response.frGuid,
                              A_GUID: response.A_GUID,
                              FileName: response.FileName,
                              ImgOcr: response.ImgOcr
                            })
                        }
                       else{
                          $toast.fail('上传失败');
                        }
                      })
                    })
                  }" multiple>
                  <van-button size="small" icon="plus" round plain type="primary"/>
                </van-uploader>
              </template>
            </van-field>
            <!--开始日期-->
            <van-popup v-model="detail.showWindows.showStartDate" position="bottom">
              <van-datetime-picker
                v-model="currentDate"
                type="datetime"
                :max-date="detail.maxDate"
                :formatter="dateTimeHalfAnHourFormatter"
                :filter="dateTimeHalfAnHourFilter"
                @cancel="detail.showWindows.showStartDate=false"
                @confirm="()=>{
                  getHolidayMinTimePart().then(response=>{
                    if(response.success){
                      if(response.code==='0000'){
                        let minPartTime = 30;
                        if (response.result && response.result !== null && response.result.length > 0) {
                          if (detail.DtsInvType === '年假') {
                            if (response.result[0].AnnualLeaveMinPart !== undefined && response.result[0].AnnualLeaveMinPart !== null && response.result[0].AnnualLeaveMinPart !== '' && Number(response.result[0].AnnualLeaveMinPart) > 0) {
                              minPartTime = parseInt(response.result[0].AnnualLeaveMinPart * 60);
                            }
                          } else if (detail.DtsInvType === '陪护假') {
                            if (response.result[0].CareLeaveMinPart !== undefined && response.result[0].CareLeaveMinPart !== null && response.result[0].CareLeaveMinPart !== '' && Number(response.result[0].CareLeaveMinPart) > 0) {
                              minPartTime = parseInt(response.result[0].CareLeaveMinPart * 60);
                            }
                          } else if (detail.DtsInvType === '育儿假') {
                              if (response.result[0].ParentalLeaveMinPart !== undefined && response.result[0].ParentalLeaveMinPart !== null && response.result[0].ParentalLeaveMinPart !== '' && Number(response.result[0].ParentalLeaveMinPart) > 0) {
                                minPartTime = parseInt(response.result[0].ParentalLeaveMinPart * 60);
                              }
                          }
                        }
                        detail.minDate=addMinutesHalfAnHourTime(currentDate,minPartTime);
                        detail.BeginDate = moment(currentDate).format('YYYY/MM/DD HH:mm');
                        calculateEmployeeHolidayTime(detail);
                        detail.showWindows.showStartDate=false
                      }
                    }
                  });
                }"
              />
            </van-popup>
            <!--结束日期-->
            <van-popup v-model="detail.showWindows.showEndDate" position="bottom">
              <van-datetime-picker
                v-model="currentDate"
                type="datetime"
                :min-date="detail.minDate"
                :formatter="dateTimeHalfAnHourFormatter"
                :filter="dateTimeHalfAnHourFilter"
                @cancel="detail.showWindows.showEndDate=false"
                @confirm="()=>{
                  getHolidayMinTimePart().then(response=>{
                    if(response.success){
                      if(response.code==='0000'){
                        let minPartTime = 30;
                        if (response.result && response.result !== null && response.result.length > 0) {
                          if (detail.DtsInvType === '年假') {
                            if (response.result[0].AnnualLeaveMinPart !== undefined && response.result[0].AnnualLeaveMinPart !== null && response.result[0].AnnualLeaveMinPart !== '' && Number(response.result[0].AnnualLeaveMinPart) > 0) {
                              minPartTime = parseInt(response.result[0].AnnualLeaveMinPart * 60);
                            }
                          } else if (detail.DtsInvType === '陪护假') {
                            if (response.result[0].CareLeaveMinPart !== undefined && response.result[0].CareLeaveMinPart !== null && response.result[0].CareLeaveMinPart !== '' && Number(response.result[0].CareLeaveMinPart) > 0) {
                              minPartTime = parseInt(response.result[0].CareLeaveMinPart * 60);
                            }
                          } else if (detail.DtsInvType === '育儿假') {
                              if (response.result[0].ParentalLeaveMinPart !== undefined && response.result[0].ParentalLeaveMinPart !== null && response.result[0].ParentalLeaveMinPart !== '' && Number(response.result[0].ParentalLeaveMinPart) > 0) {
                                minPartTime = parseInt(response.result[0].ParentalLeaveMinPart * 60);
                              }
                          }
                        }
                        detail.maxDate=addMinutesHalfAnHourTime(currentDate,-minPartTime);
                        detail.EndDate = moment(currentDate).format('YYYY/MM/DD HH:mm');
                        calculateEmployeeHolidayTime(detail);
                        detail.showWindows.showEndDate=false
                      }
                    }
                  })
                }"
              />
            </van-popup>
            <!--请假类型-->
            <van-popup v-model="detail.showWindows.showTakeOffType" round position="bottom">
              <van-picker
                show-toolbar
                :columns="takeoffTypeList"
                @cancel="detail.showWindows.showTakeOffType = false"
                @confirm="(item,index)=>{
                  detail.DtsInvType=item.value;
                  detail.minDate=new Date((new Date().getFullYear()-10)+'-01-01 00:00');//最小日期设置为当前时间
                  detail.maxDate=new Date((new Date().getFullYear()+10)+'-12-31 23:59');//最大日期设置为当前时间
                  detail.BeginDate='';
                  detail.EndDate='';
                  detail.showWindows.showTakeOffType = false
                }"
              />
            </van-popup>
          </van-collapse-item>
        </div>
      </van-collapse>
      <div class="add-detail" @click="addDetails"><i class="iconfont iconfont-zengjia"></i>添加明细</div>
      <div class="pr5 pl5">
        <van-button block type="info">提交</van-button>
      </div>
    </van-form>
    <!--岗位弹框-->
    <van-popup v-model="showPostPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="postList"
        @cancel="showPostPicker = false"
        @confirm="onPost"
      />
    </van-popup>
  </section>
</template>

<script>
  import {getUserPostListApi,calculateEmployeeHolidayTimeApi, submitApplyFormApi} from '@/api/reimbursement'
  import {fileUploadApi,getLeaveValidityPeriodApi} from '@/api/common'
  export default {
    data() {
      return {
        isShow: true,//是否显示
        showPostPicker: false,//弹出岗位弹框
        currentDate: new Date(),//当前日期
        applyInfo: {
          Post: {text: '', value: ''},//发起岗位
          summary:'',//请假事由
          details: [{
            GUID: this.guid(),//生成唯一的GUID
            DtsInvType: '事假',//请假类型
            BeginDate: '',//开始时间
            EndDate: '',//结束时间
            minDate:new Date((new Date().getFullYear()-10)+"-01-01 00:00"),//最小日期设置为当前时间
            maxDate:new Date((new Date().getFullYear()+10)+"-12-31 23:59"),//最大日期设置为当前时间
            Remark: '',//请假事由
            subsidyAmt: '0.00',//请假时长
            DtsInvTypeUnit: '小时',//时长单位
            uploader: [],//需要上传的文件
            fileList: [],//存储上传的文件
            //弹框对象
            showWindows: {
              showTakeOffType: false,
              showStartDate: false,
              showEndDate: false,
            },
          }],
        },
        postList: [
          {text: "", value: ""}
        ],//岗位列表
        //请假类型列表
        takeoffTypeList: [{
          text: '事假',
          value: '事假'
        }, {
          text: '病假',
          value: '病假'
        }, {
          text: '年假',
          value: '年假'
        }, {
          text: '调休',
          value: '调休'
        }, {
          text: '探亲假',
          value: '探亲假'
        }, {
          text: '婚假',
          value: '婚假'
        }, {
          text: '产假',
          value: '产假'
        }, {
          text: '丧假',
          value: '丧假'
        }, {
          text: '陪护假',
          value: '陪护假'
        }, {
          text: '育儿假',
          value: '育儿假'
        }, {
          text: '其它',
          value: '其它'
        }],
        activeNames: [0],//请假明细分组名称
      }
    },
    mounted() {
      this.getUserPostList();
    },
    methods: {
      //获取用户岗位列表
      async getUserPostList() {
        let userInfo = this.getCookie("UserInfo");
        let companyInfo = this.getCookie("CompanyInfo");
        let params = {
          cGuid: companyInfo.companyId,
          uGuid: userInfo.U_GUID
        };
        let response = await getUserPostListApi(params);
        if (response.success) {
          if (response.result.length) {
            let arr = new Array();
            response.result.forEach(function (item, index) {
              let data = new Object();
              data.text = item.PostName;
              data.value = item.GUID;
              arr.push(data);
            });
            if(arr!=undefined&&arr!=null&&arr.length>0) {
              this.postList = arr;
              this.applyInfo.Post = arr[0];
            }
          }
        }
      },
      //选择岗位
      onPost(item) {
        this.applyInfo.Post.value = item.value;
        this.applyInfo.Post.text = item.text;
        this.showPostPicker = false;
      },
      //上传至服务器
      async fileUpload(file,detail) {
        //此时可以自行将文件上传至服务器
        let userInfo = this.getCookie("UserInfo");
        let companyInfo = this.getCookie("CompanyInfo");
        let formData = new FormData();
        formData.append("cGuid", companyInfo.companyId);
        formData.append("uGuid", userInfo.U_GUID);
        formData.append("frGuid", detail.GUID);
        formData.append("TempFileNameFirst", "1");
        formData.append("Type", "OCR");
        formData.append("sequence", detail.GUID);
        formData.append("RelationType", "FL");
        formData.append("scanType", "");
        formData.append("categoryGuid", "74FD3D28-B288-465A-9059-4A267D030878");
        formData.append("isTemp", "true");
        formData.append("file", file);
        return await fileUploadApi(formData);
      },
      //获取假期最小时间段
      async getHolidayMinTimePart() {
        let companyInfo = this.getCookie("CompanyInfo");
        let params = {
          cGuid: companyInfo.companyId
        };
        return await getLeaveValidityPeriodApi(params);
      },
      //根据时间计算假勤总时长
      async calculateEmployeeHolidayTime(details) {
        let beginDate = details.BeginDate;
        let endDate = details.EndDate;
        if (beginDate != undefined && beginDate != null && beginDate != "" && beginDate.length > 0 && endDate != undefined && endDate != null && endDate != "" && endDate.length > 0) {
          let companyInfo = this.getCookie("CompanyInfo");
          let params = {
            cGuid: companyInfo.companyId,
            beginDate: beginDate,
            endDate: endDate,
            formType: 'FL'
          };
          let response = await calculateEmployeeHolidayTimeApi(params);
          if (response.success) {
            if (response.result.length) {
              details.subsidyAmt = response.result;
            }
          }
        }
      },
      //增加报销明细
      addDetails() {
        this.applyInfo.details.push({
          GUID: this.guid(),//生成唯一的GUID
          DtsInvType: '事假',//请假类型
          BeginDate: '',//开始时间
          EndDate: '',//结束时间
          minDate:new Date((new Date().getFullYear()-10)+"-01-01 00:00"),//最小日期设置为当前时间
          maxDate:new Date((new Date().getFullYear()+10)+"-12-31 23:59"),//最大日期设置为当前时间
          Remark: '',//请假事由
          subsidyAmt: '0.00',//请假时长
          DtsInvTypeUnit: '小时',//时长单位
          uploader: [],//需要上传的文件
          fileList: [],//存储上传的文件
          //弹框对象
          showWindows: {
            showTakeOffType: false,
            showStartDate: false,
            showEndDate: false,
          },
        })
        if(this.applyInfo.details!==undefined&&this.applyInfo.details!==null&&this.applyInfo.details.length>0) {
          this.activeNames = [this.applyInfo.details.length - 1];
        }
      },
      //移除报销明细
      removeDetails(index){
        this.applyInfo.details.splice(index,1);
        if(this.applyInfo.details!==undefined&&this.applyInfo.details!==null&&this.applyInfo.details.length>0) {
          this.activeNames = [this.applyInfo.details.length - 1];
        }
      },
      //提交表单
      async save() {
        this.isShow = false;
        let postGuid = this.applyInfo.Post.value;
        let approvalGuid = this.guid();
        let userInfo = this.getCookie("UserInfo");
        let companyInfo = this.getCookie("CompanyInfo");
        let paylist = new Array();
        this.applyInfo.details.forEach((v, i) => {
          let approvalDetailGuid = v.GUID;
          let beginDate = v.BeginDate;
          let endDate = v.EndDate;
          let subsidyAmt = v.subsidyAmt.replace(/,/g, "");
          let invTypeDts = v.DtsInvType;
          let invTypeUnit = v.DtsInvTypeUnit;
          let remark = v.Remark;
          let pay = new Object;
          pay.Approval_GUID = approvalGuid;
          pay.Approval_Sub_GUID = approvalDetailGuid;
          pay.FormType = 'FL';
          pay.BeginDate = beginDate;
          pay.EndDate = endDate;
          pay.InvTypeDts = invTypeDts;
          pay.Remark = remark;
          pay.Post_GUID = postGuid;
          pay.SumLeave = subsidyAmt;
          pay.LeaveType = invTypeDts;
          pay.LeaveTypeUnit = invTypeUnit;
          pay.C_GUID = companyInfo.companyId;
          paylist.push(pay);
        });
        let approvalFormInfo = new Object;
        approvalFormInfo.Approval_GUID = approvalGuid;
        approvalFormInfo.FormType = 'FL';
        approvalFormInfo.Post_GUID = postGuid;
        approvalFormInfo.Remark = this.applyInfo.summary;
        approvalFormInfo.C_GUID = companyInfo.companyId;
        approvalFormInfo.U_GUID = userInfo.U_GUID;
        approvalFormInfo.Creator = userInfo.NickName;
        approvalFormInfo.CompanyName = companyInfo.companyName;
        approvalFormInfo.UserName = userInfo.TelName || userInfo.LoginName;
        approvalFormInfo.ApplyName = userInfo.NickName || (userInfo.FirstName+userInfo.LastName);
        approvalFormInfo.detailFLLists = paylist;
        let params = {
          ...approvalFormInfo
        };
        let response = await submitApplyFormApi(params);
        if (response.success) {
          if (response.code === "0000") {
            this.isShow = true;
            this.$router.push({path: "/follow"})
            return;
          }
          this.$toast.fail(response.msg);
          return;
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .wrapper {
    height: calc(100vh - 5rem);
    ::v-deep.van-hairline--top-bottom{
      .van-remove-detail-items {
        position: relative;
        height: 100%;
        .van-remove-detail {
          display: flex;
          position: absolute;
          right: 3rem;
          z-index: 5;
          text-align: center;
          align-items: center;
          padding: 10px 16px;
          line-height: 24px;
          color: #0066ff;
          font-size: 1.4rem;
          .iconfont-style{
            font-size:1.1rem;
          }
        }
      }
    }
    .add-detail {
      color: #0066ff;
      text-align: center;
      padding: 1rem 0;
      font-size: 1.4rem;
    }
    ::v-deep.van-field__error-message{
      text-align: right;
    }
    ::v-deep.van-collapse-item__content {
      padding: 0;
    }

    ::v-deep.van-collapse-item__title {
      background: #f6f6f8;
    }
    .user-card {
      display: inline-flex;
      padding: 5px;
      color: black;
      font-size: 1.6rem;
      background: #f3f3f3;
      flex-direction: row;
      align-items: center;
      margin-top: 1rem;
      vertical-align: middle;
      margin-right: 1rem;

      &-profile {
        width: 3.5rem;
        height: 3.5rem;
      }
    }
  }
</style>
